












import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import SupplierForm from '@superUI/Forms/SupplierForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "SupplierCreate"
  components: { Back, SuperContainerView, SupplierForm, RequestButton }
  resources:
    newSupplier:
        resourceName: 'supplier'
        slug: 'suppliers/new'
  vue:
    methods:
      onSave: (item) -> @$router.push({ name: 'SupplierShowPage', params: { supplierId: item.id } })

      hiSave: ->
        @prime.newSupplier.parent_organization_id = @$route.query.supplierId if @$route.query.supplierId?
        @saveItem('prime.newSupplier')

export default VueOptions.vue settings
